<ng-template #customComponent>
</ng-template>